<script>
  import { user } from "../../stores/User"
  import { BASE_URL } from "../../stores/BASE_URL"
  import { navigate } from "svelte-routing"
  import SinInformacion from "../Sin_informacion.svelte"
  import Spinner from "../Spinner.svelte"
  import OpcionalLicencia from "./Opcional_licencia.svelte"

  export let documento

  let licencias = []
  let loading = true
  let error = false

  const cargarDatos = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}persona.php?documento=${documento}&session_key=${$user.session_key}&ops=otros_licencia`,
      )
      if (!response.ok) throw new Error("No se pudo consultar la licencia")

      const resp = await response.json()
      if (resp.status == "error") {
        navigate("/", { replace: true })
        return
      }

      licencias = Array.isArray(resp.data) ? resp.data : []
    } catch (err) {
      console.error("Error al cargar la licencia de conducir:", err)
      error = true
    } finally {
      loading = false
    }
  }

  cargarDatos()
</script>

{#if loading}
  <Spinner message="Actualizando en linea" online={true} />
{:else if error}
  <p role="alert">No se pudo cargar la licencia de conducir. Intenta nuevamente más tarde.</p>
{:else if licencias.length === 0}
  <SinInformacion />
{:else}
  <OpcionalLicencia {licencias} />
{/if}
